var React = require('react');

function StepCircle0648px (props) {
    return React.createElement("symbol",props,React.createElement("path",{"fillRule":"evenodd","d":"M24 46C11.85 46 2 36.15 2 24S11.85 2 24 2s22 9.85 22 22-9.85 22-22 22m0-46C10.745 0 0 10.745 0 24s10.745 24 24 24 24-10.745 24-24S37.255 0 24 0m4.147 14.84v1.872c-.468-.026-1.066.026-1.716.13-3.614.572-5.486 3.172-5.876 5.98h.052c.806-1.092 2.236-1.976 4.108-1.976 2.99 0 5.096 2.184 5.096 5.46 0 3.12-2.106 5.98-5.642 5.98-3.588 0-5.954-2.808-5.954-7.202 0-3.328 1.17-5.954 2.86-7.618 1.404-1.378 3.276-2.236 5.408-2.496.676-.104 1.248-.13 1.664-.13zm-3.952 15.678h.026c1.95 0 3.276-1.638 3.276-4.056s-1.378-3.874-3.484-3.874c-1.378 0-2.678.832-3.302 2.08a2.13 2.13 0 0 0-.234.988c.026 2.782 1.326 4.862 3.718 4.862z"}));
}

StepCircle0648px.displayName = "StepCircle0648px";

StepCircle0648px.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = StepCircle0648px;

StepCircle0648px.default = StepCircle0648px;



//////////////////
// WEBPACK FOOTER
// ./data/assets/sprites/48px/step-circle-06-48px.svg
// module id = 1157
// module chunks = 0